import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { store } from '../store';
import { ThemeProvider } from '../contexts/ThemeContext';
import i18n from '@/shared/i18n/config';

interface AppProvidersProps {
  children: React.ReactNode;
}

const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <HelmetProvider>
          <I18nextProvider i18n={i18n}>
            <ThemeProvider>
              {children}
            </ThemeProvider>
          </I18nextProvider>
        </HelmetProvider>
      </BrowserRouter>
    </Provider>
  );
};

export default AppProviders;

